// src/views/Landing/LandingHero.jsx
import React from 'react';
import { SiFacebook, SiSnapchat } from 'react-icons/si';
import OnboardingWizard from '../../components/OnboardingWizard';
import styles from '../../styles/Testimonials.module.css';

export default function LandingHero({
  onNav,
  onChoosePath,
  wizardOpen,
  wizardService,
  referralUsername,
  wizardSession,
  onCloseWizard,
}) {
  return (
    <section
      id="home"
      className={`${styles.heroSection} ${wizardOpen ? styles.heroSectionWizardMode : ''}`}
      data-anim
    >
      <div className={styles.sectionBgRoot} aria-hidden="true">
        <div className={`${styles.sectionOrb} ${styles.sectionOrbPink}`} />
        <div className={`${styles.sectionOrb} ${styles.sectionOrbSky}`} />
        <div className={styles.sectionAurora} />
      </div>

      <div className={styles.heroStage}>
        <div
          className={`${styles.heroLayer} ${wizardOpen ? styles.heroLayerInactive : styles.heroLayerActive}`}
          aria-hidden={wizardOpen}
        >
          <div className={styles.heroLayerScroll}>
            <header className={styles.onboardHeader}>
              <p className={styles.onboardKicker}>Creator onboarding</p>
              <h1 className={styles.onboardTitle}>Choose your path to continue</h1>
              <p className={styles.onboardHint}>
                The guided form opens in this panel — same flow, designed for full-screen focus.
              </p>
            </header>

            <div className={styles.pathSection}>
              <div className={styles.pathGrid}>
                <button
                  type="button"
                  className={styles.pathCard}
                  onClick={() => onChoosePath('facebook')}
                >
                  <span className={styles.pathCardIcon} aria-hidden="true">
                    <SiFacebook size={28} />
                  </span>
                  <span className={styles.pathCardTitle}>Facebook Page Management</span>
                  <span className={styles.pathCardDesc}>Page growth &amp; management track.</span>
                  <span className={styles.pathCardCta}>Start wizard →</span>
                </button>
                <button
                  type="button"
                  className={`${styles.pathCard} ${styles.pathCardAlt}`}
                  onClick={() => onChoosePath('snapchat')}
                >
                  <span className={styles.pathCardIcon} aria-hidden="true">
                    <SiSnapchat size={28} />
                  </span>
                  <span className={styles.pathCardTitle}>Snapchat Star Acquisition</span>
                  <span className={styles.pathCardDesc}>Snap Star acquisition track.</span>
                  <span className={styles.pathCardCta}>Start wizard →</span>
                </button>
              </div>
            </div>

            <p className={styles.heroResultsHint}>
              <button type="button" className={styles.resultsLink} onClick={() => onNav('testimonials')}>
                See creator results
              </button>
            </p>
          </div>
        </div>

        <div
          className={`${styles.heroLayer} ${styles.heroLayerWizard} ${
            wizardOpen ? styles.heroLayerActive : styles.heroLayerInactive
          }`}
          aria-hidden={!wizardOpen}
        >
          {wizardOpen && (
            <div className={styles.heroWizardMount}>
              <OnboardingWizard
                key={wizardSession}
                variant="embedded"
                referralUsername={referralUsername}
                skipServiceStep={Boolean(wizardService)}
                initialService={wizardService}
                onClose={onCloseWizard}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
